(function(){
  'use strict';

  var I = window.IvePopupI18n || {};
  var SWIPER_URL = window.IvePopupSwiperUrl || '';

  var popupData = {};
  var lightboxSwiper = null;

  /* ---- Icon cache ---- */
  var _templates = document.getElementById('ive-popup-icon-templates');
  function _cloneIcon(selector) {
    if (!_templates) return null;
    var el = _templates.querySelector(selector);
    return el ? el.cloneNode(true) : null;
  }
  function getCloseIcon() { return _cloneIcon('[data-ive-icon="menu-close"]'); }
  function getArrowLeft() { return _cloneIcon('[data-ive-icon="arrow-left"]'); }
  function getArrowRight() { return _cloneIcon('[data-ive-icon="arrow-right"]'); }
  function getArrowClose() { return _cloneIcon('[data-ive-icon="arrow-close"]'); }

  /* ---- Discount helpers ---- */
  function getDiscountConfig() {
    var el = document.getElementById('ive-popup-discount-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getDiscountCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    var code = m ? decodeURIComponent(m[1]) : null;
    if (code) {
      try {
        sessionStorage.setItem('ive_discount_code', code);
        sessionStorage.setItem('ive_discount_ts', Date.now());
      } catch (e) {}
      return code;
    }
    try {
      var saved = sessionStorage.getItem('ive_discount_code');
      var ts = sessionStorage.getItem('ive_discount_ts');
      if (saved && ts && (Date.now() - parseInt(ts, 10) < 7 * 24 * 60 * 60 * 1000)) {
        return saved;
      }
    } catch (e) {}
    return null;
  }

  function isDiscountActive(config) {
    if (!config) return false;
    if (config.auto) return true;
    var code = getDiscountCookie();
    return code && config.codes.some(function(c) { return c === btoa(code); });
  }

  function formatMoneyCents(cents) {
    if (window.themeCore && window.themeCore.utils && window.themeCore.utils.formatMoney) {
      var fmt = (window.themeCore.objects && window.themeCore.objects.shop && window.themeCore.objects.shop.money_format) || '{{amount}}';
      var html = window.themeCore.utils.formatMoney(cents, fmt);
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || html;
    }
    return (cents / 100).toFixed(2);
  }

  function calcDiscountedPrice(originalCents, config) {
    switch (config.type) {
      case '百分比':
        if (config.value >= 100) return 0;
        return Math.round(originalCents * (1 - config.value / 100));
      case '固定金额':
        return Math.max(0, originalCents - Math.round(config.value * 100));
      case '免费':
        return 0;
      default:
        return originalCents;
    }
  }

  function applyDiscountToItem(itemEl, config) {
    var checkbox = itemEl.querySelector('.js-ive-popup-rec-check');
    var select = itemEl.querySelector('.js-ive-popup-recommend-variant-select');
    var originalPriceRaw;

    if (select) {
      var opt = select.options[select.selectedIndex];
      originalPriceRaw = parseInt(opt.dataset.originalPriceRaw, 10) || parseInt(opt.dataset.priceRaw, 10) || 0;
    } else {
      originalPriceRaw = parseInt(checkbox.dataset.originalPriceRaw, 10) || parseInt(checkbox.dataset.priceRaw, 10) || 0;
    }

    var discounted = calcDiscountedPrice(originalPriceRaw, config);

    checkbox.setAttribute('data-price-raw', discounted);
    if (select) {
      select.options[select.selectedIndex].setAttribute('data-price-raw', discounted);
    }

    var priceEl = itemEl.querySelector('.recommend-product-price');
    if (!priceEl) return;
    var ins = priceEl.querySelector('.js-price__current');
    var del = priceEl.querySelector('.js-price__compare');

    if (ins) {
      var isFree = config.type === '免费' || (config.type === '百分比' && config.value >= 100) || discounted === 0;
      ins.textContent = isFree ? (config.freeLabel || 'Free') : formatMoneyCents(discounted);
    }

    var displayOriginal = formatMoneyCents(originalPriceRaw);
    if (del) {
      del.textContent = displayOriginal;
      del.style.fontSize = 'var(--12-14)';
    } else {
      del = document.createElement('del');
      del.className = 'js-price__compare';
      del.style.fontSize = 'var(--12-14)';
      del.textContent = displayOriginal;
      priceEl.appendChild(del);
    }

    var recommendDiv = itemEl.querySelector('.js-recommend-checkbox');
    if (recommendDiv) {
      var savings = originalPriceRaw - discounted;
      var tag = recommendDiv.querySelector('.dealtag');
      if (savings > 0) {
        if (!tag) {
          tag = document.createElement('div');
          tag.className = 'dealtag absolute';
          tag.style.cssText = 'right:-2px;top:-2px;font-size:14px;background:var(--brandmaincolor);color:#fff;padding:3px 6px;';
          recommendDiv.appendChild(tag);
        }
        tag.textContent = config.bundleLabel + ' -' + formatMoneyCents(savings);
        tag.style.display = '';
        recommendDiv.style.padding = '16px 0';
      }
    }
  }

  function applyDiscountToAllItems(container) {
    var config = getDiscountConfig();
    if (!isDiscountActive(config)) return;

    container.querySelectorAll('.js-product-item').forEach(function(item) {
      if (item.querySelector('.js-ive-popup-rec-check[data-original-price-raw]')) {
        applyDiscountToItem(item, config);
      }
    });

    if (config.type === '免费') {
      container.querySelectorAll('.js-ive-popup-rec-check[data-original-price-raw]').forEach(function(box) {
        box.checked = true;
      });
      if (container._updateTotalPrice) container._updateTotalPrice();
    }
  }

  /* ---- Dynamic element builders ---- */

  function buildSpinner() {
    var div = document.createElement('div');
    div.className = 'ive-popup-loading flex align-center justify-center flex-col';
    div.style.cssText = 'max-height: 80vh; height: 642px; gap:16px;';
    div.innerHTML = '<div class="ive-popup-spinner" style="width:40px; height:40px; border:4px solid #e5e7eb; border-top-color:var(--brandmaincolor, #fd5501); border-radius:50%; animation:ive-spin 0.8s linear infinite;"></div><span style="font-size:14px; color:#757575;">' + (I.loading || 'Loading...') + '</span>';
    return div;
  }

  function buildOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 'ive-popup-overlay fixed js-ive-popup-overlay';
    overlay.style.cssText = 'overflow-y: auto;z-index: 2147483648;background: rgba(0, 0, 0, 0.5);inset: 0px;';
    var container = document.createElement('div');
    container.className = 'ive-popup-container js-ive-popup-container relative';
    container.style.cssText = 'background: #fff;max-width: 1000px;margin: 0 auto;border-radius: 12px;';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'js-ive-popup-close ive-popup-close pointer flex align-center justify-center';
    closeBtn.setAttribute('aria-label', 'Close popup');
    closeBtn.style.cssText = 'position: absolute;top: 0;right: 0;z-index: 10;border-width: medium;border-style: none;background: #ffffff;width: 32px;height: 32px;border-radius: 50%;';
    closeBtn.appendChild(getCloseIcon());

    var contentSlot = document.createElement('div');
    contentSlot.className = 'js-ive-popup-content ive-popup-content';
    contentSlot.style.cssText = 'border-radius: 12px;';
    contentSlot.appendChild(buildSpinner());

    container.appendChild(closeBtn);
    container.appendChild(contentSlot);
    overlay.appendChild(container);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closePopup();
    });
    closeBtn.addEventListener('click', closePopup);

    return overlay;
  }

  function buildLightbox() {
    var el = document.createElement('div');
    el.className = 'ive-popup-lightbox js-ive-popup-lightbox ive-product-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Image zoom');

    var bg = document.createElement('div');
    bg.className = 'js-ive-popup-lightbox-bg absolute full-width full-height';
    bg.style.cssText = 'top:0; left:0; background:rgba(0,0,0,0.9);';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'js-ive-popup-lightbox-close ive-product-lightbox__close absolute pointer rounded-full';
    closeBtn.setAttribute('aria-label', 'Close lightbox');
    closeBtn.style.cssText = 'top: 5%; right: 5%;  transform: translate(50%, -50%); border: none; z-index: 2;';
    closeBtn.appendChild(getArrowClose());

    var swiperEl = document.createElement('div');
    swiperEl.className = 'swiper js-ive-popup-lightbox-swiper relative full-width';
    swiperEl.style.height = '90%';
    swiperEl.innerHTML = '<div class="swiper-wrapper"></div>';

    var prevBtn = document.createElement('div');
    prevBtn.className = 'swiper-button-prev ive-popup-swiper-btn';
    prevBtn.appendChild(getArrowLeft());

    var nextBtn = document.createElement('div');
    nextBtn.className = 'swiper-button-next ive-popup-swiper-btn';
    nextBtn.appendChild(getArrowRight());

    swiperEl.appendChild(prevBtn);
    swiperEl.appendChild(nextBtn);

    el.appendChild(bg);
    el.appendChild(closeBtn);
    el.appendChild(swiperEl);

    bg.addEventListener('click', closeLightbox);
    closeBtn.addEventListener('click', closeLightbox);

    return el;
  }

  /* ---- Popup state management ---- */

  function showOverlay(overlay) {
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  function hideOverlay(overlay) {
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function destroySwipersIn(el) {
    if (!el) return;
    var swipers = el.querySelectorAll('.swiper');
    swipers.forEach(function(s) {
      if (s.swiper) { s.swiper.destroy(true, false); s.swiper = null; }
    });
  }

  function destroyPopupSwipers() {
    var productDiv = document.querySelector('.ive-popup-product');
    if (productDiv) destroySwipersIn(productDiv);
  }

  function swiperReady(fn) {
    if (typeof Swiper !== 'undefined') { fn(); return; }
    var tries = 0;
    var t = setInterval(function() {
      if (typeof Swiper !== 'undefined') { clearInterval(t); fn(); }
      if (++tries > 50) clearInterval(t);
    }, 100);
  }

  /* ---- Init Gallery ---- */

  function initPopupGallery(container) {
    var galleryEl = container.querySelector('.js-ive-popup-gallery');
    if (!galleryEl || galleryEl.swiper) return;
    var thumbsEl = container.querySelector('.js-ive-popup-thumbs');
    var thumbsSwiper = null;

    if (thumbsEl && !thumbsEl.swiper) {
      thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
      });
      thumbsEl.swiper = thumbsSwiper;
    }

    var config = { nested: true, observer: true, observeParents: true, resizeObserver: true };
    var paginationEl = galleryEl.querySelector('.js-ive-popup-pagination');
    if (paginationEl) {
      config.pagination = { el: paginationEl, type: 'fraction' };
    }
    var nextEl = galleryEl.querySelector('.swiper-button-next');
    var prevEl = galleryEl.querySelector('.swiper-button-prev');
    if (nextEl && prevEl) {
      config.navigation = { nextEl: nextEl, prevEl: prevEl };
    }
    if (thumbsSwiper) {
      config.thumbs = { swiper: thumbsSwiper };
    }
    var sw = new Swiper(galleryEl, config);
    galleryEl.swiper = sw;
    return sw;
  }

  function initPopupVideoGallery(container) {
    var videoGalleryEl = container.querySelector('.js-ive-popup-video-gallery');
    if (!videoGalleryEl || videoGalleryEl.swiper) return;
    var videoThumbsEl = container.querySelector('.js-ive-popup-video-thumbs');
    var videoThumbsSwiper = null;

    if (videoThumbsEl && !videoThumbsEl.swiper) {
      videoThumbsSwiper = new Swiper(videoThumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
      });
      videoThumbsEl.swiper = videoThumbsSwiper;
    }

    var config = {
      nested: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: {
        nextEl: videoGalleryEl.querySelector('.swiper-button-next'),
        prevEl: videoGalleryEl.querySelector('.swiper-button-prev'),
      },
      on: {
        slideChange: function() {
          var prev = this.slides[this.previousIndex];
          if (prev) {
            prev.querySelectorAll('video').forEach(function(v) { v.pause(); });
          }
        }
      }
    };
    if (videoThumbsSwiper) {
      config.thumbs = { swiper: videoThumbsSwiper };
    }
    var sw = new Swiper(videoGalleryEl, config);
    videoGalleryEl.swiper = sw;
    return sw;
  }

  function initPopupMediaTabs(container) {
    var tabsContainer = container.querySelector('.js-ive-popup-media-tabs');
    var tabs = container.querySelectorAll('.js-ive-popup-media-tab');
    if (!tabsContainer || tabs.length === 0) return;
    if (tabsContainer.swiper) return;

    var sw = new Swiper(tabsContainer, {
      allowTouchMove: false,
      autoHeight: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      on: {
        slideChange: function() {
          var prev = this.slides[this.previousIndex];
          if (prev) {
            prev.querySelectorAll('video').forEach(function(v) { v.pause(); });
          }
          tabs.forEach(function(t) { t.classList.remove('active'); });
          var activeTab = container.querySelector('.js-ive-popup-media-tab[data-popup-slide="' + this.activeIndex + '"]');
          if (activeTab) activeTab.classList.add('active');
          var activeSlide = this.slides[this.activeIndex];
          if (activeSlide) {
            var gallery = activeSlide.querySelector('.js-ive-popup-gallery, .js-ive-popup-video-gallery');
            if (gallery && gallery.swiper) {
              gallery.swiper.update();
            }
          }
        }
      }
    });
    tabsContainer.swiper = sw;

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var idx = parseInt(this.dataset.popupSlide, 10);
        sw.slideTo(idx);
        tabs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ---- Variant Selection ---- */

  function initPopupVariantSelection(container) {
    var variantInfoEl = container.querySelector('script[data-popup-variant-info]');
    if (!variantInfoEl) { console.warn('[Popup] variant info script not found in container'); return; }
    var variantInfo;
    try { variantInfo = JSON.parse(variantInfoEl.textContent); } catch(e) { console.error('[Popup] variant info parse error:', e); return; }
    popupData.variantInfo = variantInfo;

    var optionGroups = container.querySelectorAll('.js-ive-popup-options .product-option');
    popupData.colorOptionIndex = parseInt(container.dataset.colorOptionIndex || '0', 10);

    function getSelectedOptions() {
      var sel = [];
      optionGroups.forEach(function(g) {
        var idx = parseInt(g.dataset.optionIndex, 10);
        var active = g.querySelector('.js-ive-popup-option.active');
        sel[idx] = active ? active.dataset.popupValue : '';
      });
      return sel;
    }

    function findVariantByOptions(opts) {
      for (var id in variantInfo) {
        if (!variantInfo.hasOwnProperty(id)) continue;
        var v = variantInfo[id];
        if (!v.options) continue;
        var match = true;
        for (var i = 0; i < opts.length; i++) {
          if (v.options[i] !== opts[i]) { match = false; break; }
        }
        if (match) return { id: id, data: v };
      }
      return null;
    }

    function updateInput() {
      var opts = getSelectedOptions();
      var variant = findVariantByOptions(opts);
      if (variant) {
        container.dataset.selectedVariant = variant.id;
        container.dataset.selectedSku = variant.data.sku || '';
      }
    }

    function updateGallery() {
      var opts = getSelectedOptions();
      var variant = findVariantByOptions(opts);
      var imageId = variant && variant.data.image_id ? variant.data.image_id : null;

      if (!imageId && variant) {
        var ci = popupData.colorOptionIndex;
        var cv = opts[ci];
        for (var id in variantInfo) {
          if (!variantInfo.hasOwnProperty(id)) continue;
          var v = variantInfo[id];
          if (v.options && v.options[ci] === cv && v.image_id) { imageId = v.image_id; break; }
        }
      }

      if (!imageId) return;
      var tabsCt = container.querySelector('.js-ive-popup-media-tabs');
      if (tabsCt && tabsCt.swiper) { tabsCt.swiper.slideTo(0); }
      var gallery = container.querySelector('.js-ive-popup-gallery');
      if (!gallery || !gallery.swiper) return;
      var slides = gallery.querySelectorAll('.swiper-slide');
      var targetIdx = -1;
      slides.forEach(function(s, i) {
        if (parseInt(s.dataset.popupImageId, 10) === imageId) targetIdx = i;
      });
      if (targetIdx >= 0) gallery.swiper.slideTo(targetIdx);
    }

    function stripHtml(str) {
      if (!str) return '';
      var tmp = document.createElement('div');
      tmp.innerHTML = str;
      return tmp.textContent || tmp.innerText || '';
    }

    function updatePrice() {
      var opts = getSelectedOptions();
      var variant = findVariantByOptions(opts);
      if (!variant) return;
      var priceEl = container.querySelector('.js-ive-popup-price');
      var compareEl = container.querySelector('.js-ive-popup-compare-price');
      if (priceEl) priceEl.textContent = stripHtml(variant.data.price_formatted);
      if (compareEl) {
        if (variant.data.compare_at_price > 0) {
          compareEl.textContent = stripHtml(variant.data.compare_at_price_formatted);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      updateTotalPrice();
    }

    function updateColorSwatches() {
      var ci = popupData.colorOptionIndex;
      var curOpts = getSelectedOptions();
      var colorGroup = container.querySelector('.product-option[data-option-index="' + ci + '"]');
      if (!colorGroup) return;
      var buttons = colorGroup.querySelectorAll('.js-ive-popup-option');
      buttons.forEach(function(btn) {
        var val = btn.dataset.popupValue;
        var temp = curOpts.slice();
        temp[ci] = val;
        var matched = findVariantByOptions(temp);
        if (!matched) {
          for (var id in variantInfo) {
            if (!variantInfo.hasOwnProperty(id)) continue;
            var v = variantInfo[id];
            if (v.options && v.options[ci] === val && v.swatch_image) { matched = { id: id, data: v }; break; }
          }
        }
        var img = btn.querySelector('.js-ive-popup-swatch-img');
        if (img && matched && matched.data.swatch_image) img.src = matched.data.swatch_image;
      });
    }

    function updateQuantityMax() {
      var opts = getSelectedOptions();
      var variant = findVariantByOptions(opts);
      if (!variant) return;
      var qtyInput = container.querySelector('.js-ive-popup-qty-input');
      if (!qtyInput) return;
      var maxQty = variant.data.inventory_quantity;
      if (maxQty <= 0) maxQty = 9999;
      qtyInput.setAttribute('max', maxQty);
      var cur = parseInt(qtyInput.value, 10) || 1;
      if (cur > maxQty) qtyInput.value = maxQty;
    }

    function updateStockStates() {
      var curSelected = getSelectedOptions();
      optionGroups.forEach(function(group) {
        var gIdx = parseInt(group.dataset.optionIndex, 10);
        var buttons = group.querySelectorAll('.js-ive-popup-option');
        buttons.forEach(function(btn) {
          var val = btn.dataset.popupValue;
          var hasAvailable = false;
          var hasMatch = false;
          for (var id in variantInfo) {
            if (!variantInfo.hasOwnProperty(id)) continue;
            var v = variantInfo[id];
            if (!v.options) continue;
            var match = true;
            for (var i = 0; i < v.options.length; i++) {
              if (i === gIdx) { if (v.options[i] !== val) { match = false; break; } }
              else { if (v.options[i] !== curSelected[i]) { match = false; break; } }
            }
            if (match) { hasMatch = true; if (v.available) { hasAvailable = true; break; } }
          }
          if (!hasMatch || !hasAvailable) {
            btn.classList.add('is-out-of-stock');
          } else {
            btn.classList.remove('is-out-of-stock');
          }
        });
      });
    }

    function updateAddToCartButton() {
      var opts = getSelectedOptions();
      var variant = findVariantByOptions(opts);
      var addBtn = container.querySelector('.js-ive-popup-add-cart');
      var addBtnText = container.querySelector('.js-ive-popup-add-cart-text');
      var buyBtn = container.querySelector('.js-ive-popup-buy-now');
      var notifyBtn = container.querySelector('.js-ive-popup-notify-trigger');
      if (!addBtn || !addBtnText) return;

      if (variant && variant.data.available) {
        addBtn.disabled = false;
        addBtn.classList.remove('is-disabled');
        addBtnText.textContent = I.addToCart || 'Add to cart';
        if (buyBtn) { buyBtn.disabled = false; buyBtn.style.display = ''; }
        if (notifyBtn) notifyBtn.style.display = 'none';
      } else {
        addBtn.disabled = true;
        addBtn.classList.add('is-disabled');
        addBtnText.textContent = I.soldOut || 'Sold out';
        if (buyBtn) buyBtn.style.display = 'none';
        if (notifyBtn) notifyBtn.style.display = '';
      }
      var skuInput = container.querySelector('.js-ive-popup-notify-sku');
      if (skuInput) skuInput.value = container.dataset.selectedSku || '';
    }

    function updateCurrentValues() {
      optionGroups.forEach(function(g) {
        var active = g.querySelector('.js-ive-popup-option.active');
        var curEl = g.querySelector('.js-ive-popup-option-current');
        if (curEl && active) curEl.textContent = active.dataset.popupValue;
      });
    }

    function formatMoney(cents) {
      if (window.themeCore && window.themeCore.utils && window.themeCore.utils.formatMoney) {
        var fmt = (window.themeCore.objects && window.themeCore.objects.shop && window.themeCore.objects.shop.money_format) || '{{amount}}';
        return stripHtml(window.themeCore.utils.formatMoney(cents, fmt));
      }
      return (cents / 100).toFixed(2);
    }

    function updateTotalPrice() {
      var opts = getSelectedOptions();
      var variant = findVariantByOptions(opts);
      if (!variant) return;
      var mainPrice = variant.data.price || 0;
      var qty = parseInt(container.querySelector('.js-ive-popup-qty-input').value, 10) || 1;
      var addonTotal = 0;
      var addonOriginalTotal = 0;
      var checkedBoxes = container.querySelectorAll('.js-ive-popup-rec-check:checked');
      checkedBoxes.forEach(function(box) {
        var productItem = box.closest('.js-product-item');
        var priceRaw = 0;
        var originalRaw = 0;
        if (productItem) {
          var select = productItem.querySelector('.js-ive-popup-recommend-variant-select');
          if (select) {
            var selectedOption = select.options[select.selectedIndex];
            if (selectedOption) {
              priceRaw = parseInt(selectedOption.dataset.priceRaw, 10) || 0;
              originalRaw = parseInt(selectedOption.dataset.originalPriceRaw, 10) || priceRaw;
            }
          } else {
            priceRaw = parseInt(box.dataset.priceRaw, 10) || 0;
            originalRaw = parseInt(box.dataset.originalPriceRaw, 10) || priceRaw;
          }
        } else {
          priceRaw = parseInt(box.dataset.priceRaw, 10) || 0;
          originalRaw = parseInt(box.dataset.originalPriceRaw, 10) || priceRaw;
        }
        addonTotal += priceRaw;
        addonOriginalTotal += originalRaw;
      });
      var total = (mainPrice + addonTotal) * qty;
      var totalEl = container.querySelector('.js-ive-popup-total-price');
      if (!totalEl) return;
      totalEl.textContent = formatMoney(total);

      var hasCheckedAddons = checkedBoxes.length > 0;
      var accRow = container.querySelector('.total-acc-price');
      var accPriceEl = document.getElementById('ive-popup-jsaccprice');
      var accSaveEl = document.getElementById('ive-popup-accsaveprice');

      if (hasCheckedAddons) {
        if (accRow) accRow.style.display = '';
        if (accPriceEl) accPriceEl.textContent = formatMoney(addonTotal * qty);
        var savings = addonOriginalTotal - addonTotal;
        if (accSaveEl && savings > 0) {
          accSaveEl.textContent = '(' + accSaveEl.dataset.label + ' ' + formatMoney(savings * qty) + ')';
          accSaveEl.style.display = '';
        } else if (accSaveEl) {
          accSaveEl.style.display = 'none';
        }
      } else {
        if (accRow) accRow.style.display = 'none';
        if (accPriceEl) accPriceEl.textContent = '';
        if (accSaveEl) accSaveEl.style.display = 'none';
      }
    }

    function handleOptionClick(e) {
      var btn = e.target.closest('.js-ive-popup-option');
      if (!btn) return;
      e.stopPropagation();
      var group = btn.closest('.product-option');
      if (!group) return;
      group.querySelectorAll('.js-ive-popup-option').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      updateStockStates();
      updateInput();
      updateGallery();
      updatePrice();
      updateCurrentValues();
      updateColorSwatches();
      updateQuantityMax();
      updateAddToCartButton();
    }

    container._updateTotalPrice = updateTotalPrice;

    var optionsContainer = container.querySelector('.js-ive-popup-options');
    if (optionsContainer) {
      optionsContainer.addEventListener('click', handleOptionClick);
    } else {
      container.addEventListener('click', handleOptionClick);
    }

    updateStockStates();
    updateInput();
    updatePrice();
    updateCurrentValues();
    updateColorSwatches();
    updateQuantityMax();
    updateAddToCartButton();
  }

  /* ---- Quantity Controls ---- */

  function initPopupQuantity(container) {
    var qtyMinus = container.querySelector('.js-ive-popup-qty-minus');
    var qtyPlus = container.querySelector('.js-ive-popup-qty-plus');
    var qtyInput = container.querySelector('.js-ive-popup-qty-input');

    function updateTotal() {
      var opts = container.querySelectorAll('.js-ive-popup-options .product-option');
      if (opts.length === 0) return;
      function findVariant() {
        var sel = [];
        opts.forEach(function(g) {
          var idx = parseInt(g.dataset.optionIndex, 10);
          var active = g.querySelector('.js-ive-popup-option.active');
          sel[idx] = active ? active.dataset.popupValue : '';
        });
        for (var id in popupData.variantInfo) {
          if (!popupData.variantInfo.hasOwnProperty(id)) continue;
          var v = popupData.variantInfo[id];
          if (!v.options) continue;
          var match = true;
          for (var i = 0; i < sel.length; i++) { if (v.options[i] !== sel[i]) { match = false; break; } }
          if (match) return { data: v };
        }
        return null;
      }
      var variant = findVariant();
      if (!variant) return;
      var price = variant.data.price || 0;
      var qty = parseInt(qtyInput.value, 10) || 1;
      var totalEl = container.querySelector('.js-ive-popup-total-price');
      if (!totalEl) return;
      if (window.themeCore && window.themeCore.utils && window.themeCore.utils.formatMoney) {
        var fmt = (window.themeCore.objects && window.themeCore.objects.shop && window.themeCore.objects.shop.money_format) || '{{amount}}';
        var tmp = document.createElement('div');
        tmp.innerHTML = window.themeCore.utils.formatMoney(price * qty, fmt);
        totalEl.textContent = tmp.textContent || tmp.innerText || '';
      }
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) { qtyInput.value = v - 1; if (container._updateTotalPrice) container._updateTotalPrice(); }
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10) || 1;
        var max = parseInt(qtyInput.getAttribute('max'), 10) || 9999;
        if (v < max) { qtyInput.value = v + 1; if (container._updateTotalPrice) container._updateTotalPrice(); }
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function() {
        var v = parseInt(qtyInput.value, 10) || 1;
        var max = parseInt(qtyInput.getAttribute('max'), 10) || 9999;
        if (v < 1) qtyInput.value = 1;
        else if (v > max) qtyInput.value = max;
        if (container._updateTotalPrice) container._updateTotalPrice();
      });
      qtyInput.addEventListener('input', updateTotal);
    }

    var recChecks = container.querySelectorAll('.js-ive-popup-rec-check');
    recChecks.forEach(function(box) {
      box.addEventListener('change', function() {
        if (container._updateTotalPrice) container._updateTotalPrice();
      });
    });

    container.querySelectorAll('.js-ive-popup-rec-check[data-original-price-raw]').forEach(function(box) {
      box.addEventListener('change', function() {
        var config = getDiscountConfig();
        if (!isDiscountActive(config)) return;
        if (config.type === '免费') {
          box.checked = true;
          if (container._updateTotalPrice) container._updateTotalPrice();
          return;
        }
        var checked = box.checked;
        container.querySelectorAll('.js-ive-popup-rec-check[data-original-price-raw]').forEach(function(other) {
          other.checked = checked;
        });
        if (container._updateTotalPrice) container._updateTotalPrice();
      });
    });
  }

  /* ---- Add to Cart, Buy Now, Notify Me ---- */

  function initPopupActions(container) {
    var addBtn = container.querySelector('.js-ive-popup-add-cart');
    var buyBtn = container.querySelector('.js-ive-popup-buy-now');
    var notifyTrigger = container.querySelector('.js-ive-popup-notify-trigger');
    var notifyModal = container.querySelector('.js-ive-popup-notify-modal');
    var notifyOverlay = container.querySelector('.js-ive-popup-notify-overlay');
    var notifyClose = container.querySelector('.js-ive-popup-notify-close');
    var notifyForm = container.querySelector('.js-ive-popup-notify-contact');
    var notifySubmit = container.querySelector('.js-ive-popup-notify-submit');
    var notifyIframe = container.querySelector('.js-ive-popup-notify-iframe');
    var notifySuccess = container.querySelector('.js-ive-popup-notify-form-success');
    var notifySkuInput = container.querySelector('.js-ive-popup-notify-sku');
    var notifyBody = container.querySelector('.js-ive-popup-notify-body');
    var notifyProductTitle = container.querySelector('.js-ive-popup-notify-product-title');

    function getSelectedVariantId() {
      return container.dataset.selectedVariant;
    }

    function getQty() {
      var qtyInput = container.querySelector('.js-ive-popup-qty-input');
      return parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
    }

    function getSelectedItemsData() {
      var items = [];
      var mainVariantId = getSelectedVariantId();
      var mainQty = getQty();
      if (!mainVariantId) return null;
      items.push({ id: mainVariantId, qty: mainQty });

      var checkedBoxes = container.querySelectorAll('.js-ive-popup-rec-check:checked');
      checkedBoxes.forEach(function(box) {
        var variantId = box.getAttribute('data-variant-id');
        if (variantId) {
          items.push({ id: variantId, qty: mainQty });
        }
      });
      return items;
    }

    /* 飞书机器人通知 — 弹窗加购和结账共用 */
    function sendFeishuNotification(label, selectedItems) {
      try {
        var productTitle = (container.querySelector('.ive-popup-title') || {}).textContent || 'N/A';
        var sku = container.dataset.selectedSku || '';
        var qty = selectedItems[0] ? selectedItems[0].qty : 1;
        var variantId = container.dataset.selectedVariant;
        var vData = variantId && popupData.variantInfo ? popupData.variantInfo[variantId] : null;
        var price = vData ? vData.price_formatted : 'N/A';
        var options = vData && vData.options ? vData.options.join(' / ') : '';

        var utm = window.iveUtm || {};
        var utmStr = '';
        if (utm.utm_source) utmStr += 'utm_source=' + utm.utm_source;
        if (utm.utm_medium) utmStr += (utmStr ? ', ' : '') + 'utm_medium=' + utm.utm_medium;
        if (utm.utm_campaign) utmStr += (utmStr ? ', ' : '') + 'utm_campaign=' + utm.utm_campaign;

        var addonStr = '';
        container.querySelectorAll('.js-ive-popup-rec-check:checked').forEach(function (box) {
          var itemEl = box.closest('.js-product-item');
          if (!itemEl) return;
          var titleEl = itemEl.querySelector('.recommend-product-title');
          var addonTitle = titleEl ? titleEl.textContent.trim() : 'N/A';
          var addonPrice = parseInt(box.dataset.priceRaw, 10) || 0;
          addonStr += '\n  + ' + addonTitle + ' (€' + (addonPrice / 100).toFixed(2) + ')';
        });

        var msg = label + '\n' +
          '产品：' + productTitle + '\n' +
          '数量：' + qty + '\n' +
          '价格：' + price + '\n' +
          'SKU：' + sku + '\n' +
          '变体：' + (options || 'N/A') + '\n' +
          (addonStr ? '配件：' + addonStr + '\n' : '') +
          (utmStr ? 'UTM：' + utmStr + '\n' : '') +
          '时间：' + new Date().toLocaleString() + '\n' +
          '链接：' + window.location.href;

        fetch(window.IVE_FEISHU_HOOK, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            msg_type: 'text',
            content: { text: msg }
          })
        }).catch(function () { /* 静默失败 */ });
      } catch (e) { /* 静默失败 */ }
    }

    if (addBtn) {
      addBtn.addEventListener('click', function() {
        var selectedItems = getSelectedItemsData();
        if (!selectedItems) return;
        var itemsForAjax = selectedItems.map(function(item) {
          return { id: parseInt(item.id, 10), quantity: item.qty };
        });

        addBtn.classList.add('is-loading');
        addBtn.disabled = true;

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsForAjax })
        })
        .then(function(resp) {
          if (resp.ok) {
            if (window.themeCore && window.themeCore.CartApi) {
              window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
            }
            sendFeishuNotification('🛒 弹窗加购', selectedItems);
            closePopup();
          }
        })
        .catch(function(err) { console.error('Add to cart error:', err); })
        .finally(function() {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
        });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function() {
        var selectedItems = getSelectedItemsData();
        if (!selectedItems) return;
        var pathSegments = selectedItems.map(function(item) {
          return item.id + ':' + item.qty;
        }).join(',');
        sendFeishuNotification('💳 弹窗直接结账', selectedItems);
        window.location.href = '/cart/' + pathSegments;
      });
    }

    function openNotifyModal() {
      if (!notifyModal) return;
      if (notifySkuInput) notifySkuInput.value = container.dataset.selectedSku || '';
      if (notifyProductTitle) notifyProductTitle.value = (container.querySelector('.ive-popup-title') || {}).textContent || '';
      if (notifyForm) notifyForm.style.display = '';
      if (notifySuccess) notifySuccess.style.display = 'none';
      if (notifySubmit) { notifySubmit.disabled = false; notifySubmit.textContent = I.notifyMeSubmit || 'Submit'; }
      notifyModal.style.display = '';
    }

    function closeNotifyModal() {
      if (!notifyModal) return;
      notifyModal.style.display = 'none';
    }

    if (notifyTrigger) {
      notifyTrigger.addEventListener('click', openNotifyModal);
      notifyTrigger.addEventListener('click', function () {
        try {
          if (!window.IVE_FEISHU_NOTIFY_HOOK) return;
          var c = container;
          var adminId = (c && c.dataset.stockAdmin) || '';
          var country = (c && c.dataset.userCountry) || (window.location.hostname === 'uk.ivelok.com' ? 'GB' : 'EU');
          var msg = '🔔 你要补货啦（弹窗）\n' +
            '国家：' + country + '\n' +
            '产品：' + ((c && c.dataset.productTitle) || 'N/A') + '\n' +
            'SKU：' + ((c && c.dataset.selectedSku) || 'N/A') + '\n' +
            '时间：' + new Date().toLocaleString() + '\n' +
            '链接：' + window.location.href;
          if (adminId) {
            msg += '\n<at user_id=\"' + adminId + '\"></at> 请尽快做出行动，确保库存正确哦';
          }
          fetch(window.IVE_FEISHU_NOTIFY_HOOK, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ msg_type: 'text', content: { text: msg } })
          }).catch(function () {});
        } catch (e) {}
      });
    }
    if (notifyClose) {
      notifyClose.addEventListener('click', closeNotifyModal);
    }
    if (notifyOverlay) {
      notifyOverlay.addEventListener('click', function(e) {
        if (e.target === notifyOverlay) closeNotifyModal();
      });
    }

    if (notifyForm) {
      notifyForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var sku = container.dataset.selectedSku || '';
        if (!sku) return;
        if (notifyBody) {
          var title = (container.querySelector('.ive-popup-title') || {}).textContent || '';
          notifyBody.value = 'Please notify me when ' + title + ' (SKU: ' + sku + ') becomes available.\nProduct URL: ' + window.location.origin + '/products/' + (container.dataset.productHandle || '');
        }
        if (notifySubmit) {
          notifySubmit.disabled = true;
          notifySubmit.textContent = I.sending || 'Sending...';
        }
        notifyForm.setAttribute('target', 'ive-popup-notify-iframe');
        notifyForm.submit();
      });
    }

    if (notifyIframe) {
      notifyIframe.addEventListener('load', function() {
        if (notifyForm) notifyForm.style.display = 'none';
        if (notifySuccess) notifySuccess.style.display = '';
        if (notifySubmit) { notifySubmit.disabled = false; notifySubmit.textContent = I.notifyMeSubmit || 'Submit'; }
      });
    }
  }

  /* ---- Lightbox ---- */

  function initPopupLightbox(container) {
    var gallery = container.querySelector('.js-ive-popup-gallery');
    if (!gallery) return;

    var lightboxImagesEl = container.querySelector('script[data-popup-lightbox-images]');
    if (!lightboxImagesEl) return;
    var lightboxImages;
    try { lightboxImages = JSON.parse(lightboxImagesEl.textContent); } catch(e) { return; }

    gallery.addEventListener('click', function(e) {
      var slide = e.target.closest('[data-popup-image-id]');
      if (!slide) return;
      var imgId = parseInt(slide.dataset.popupImageId, 10);
      var startIdx = 0;
      lightboxImages.forEach(function(img, i) {
        if (String(imgId) === String(img.id)) startIdx = i;
      });
      openLightbox(lightboxImages, startIdx);
    });
  }

  function openLightbox(images, startIdx) {
    var existing = document.querySelector('.js-ive-popup-lightbox');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var lightboxEl = buildLightbox();
    var swiperEl = lightboxEl.querySelector('.js-ive-popup-lightbox-swiper');

    var slidesHtml = images.map(function(img) {
      return '<div class="swiper-slide align-center justify-center"><img src="' + img.url + '" alt="' + (img.alt || '') + '" loading="lazy" width="' + (img.width || '') + '" height="' + (img.height || '') + '" style="object-fit:contain; max-width:90%; max-height:90%;"></div>';
    }).join('');

    swiperEl.querySelector('.swiper-wrapper').innerHTML = slidesHtml;
    document.body.appendChild(lightboxEl);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    if (lightboxSwiper) { lightboxSwiper.destroy(true, false); lightboxSwiper = null; }

    lightboxSwiper = new Swiper(swiperEl, {
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: swiperEl.querySelector('.swiper-button-next'),
        prevEl: swiperEl.querySelector('.swiper-button-prev'),
      },
      initialSlide: startIdx,
    });
  }

  function closeLightbox() {
    var lightboxEl = document.querySelector('.js-ive-popup-lightbox');
    if (lightboxEl && lightboxEl.parentNode) {
      if (lightboxSwiper) { lightboxSwiper.destroy(true, false); lightboxSwiper = null; }
      lightboxEl.parentNode.removeChild(lightboxEl);
    }
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  /* ---- Core: Open Popup ---- */

  var currentOverlay = null;

  function openPopup(productHandle) {
    if (!productHandle) return;

    closePopup();

    var overlay = buildOverlay();
    currentOverlay = overlay;
    showOverlay(overlay);

    var contentSlot = overlay.querySelector('.js-ive-popup-content');

    var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'products/' + productHandle + '?view=popup-product';

    fetch(url)
      .then(function(resp) {
        if (!resp.ok) throw new Error('Failed to load product');
        return resp.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var productDiv = doc.querySelector('.ive-popup-product');
        if (!productDiv) {
          contentSlot.innerHTML = '<div style="text-align:center; padding:40px;">Product not found</div>';
          return;
        }
        popupData = {};
        contentSlot.innerHTML = '';
        contentSlot.appendChild(productDiv);

        initPopupVariantSelection(productDiv);
        initPopupQuantity(productDiv);
        initPopupActions(productDiv);
        applyDiscountToAllItems(productDiv);

        swiperReady(function() {
          try { initPopupGallery(productDiv); } catch(e) { console.error('Popup gallery init error:', e); }
          try { initPopupVideoGallery(productDiv); } catch(e) { console.error('Popup video gallery init error:', e); }
          try { initPopupMediaTabs(productDiv); } catch(e) { console.error('Popup media tabs init error:', e); }
          try { initPopupLightbox(productDiv); } catch(e) { console.error('Popup lightbox init error:', e); }

          setTimeout(function() {
            productDiv.querySelectorAll('.js-ive-popup-gallery, .js-ive-popup-video-gallery').forEach(function(el) {
              if (el.swiper) el.swiper.update();
            });
            var mediaTabs = productDiv.querySelector('.js-ive-popup-media-tabs');
            if (mediaTabs && mediaTabs.swiper) mediaTabs.swiper.updateAutoHeight();
          }, 100);
        });

        if (window.jdgm && typeof window.jdgm.loadBadge === 'function') {
          try { window.jdgm.loadBadge(); } catch(e) {}
        }
      })
      .catch(function(err) {
        console.error('Popup load error:', err);
        contentSlot.innerHTML = '<div style="text-align:center; padding:40px; color:#fd5501;">Failed to load product. Please refresh the page.</div>';
      });
  }

  function closePopup() {
    destroyPopupSwipers();
    closeLightbox();
    popupData = {};
    if (currentOverlay) {
      hideOverlay(currentOverlay);
      currentOverlay = null;
    }
  }

  /* ---- Trigger Detection ---- */

  function initTrigger() {
    document.body.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-ive-popup-handle]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = trigger.getAttribute('data-ive-popup-handle');
      if (handle) openPopup(handle);
    });
  }

  function initKeyboard() {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var lb = document.querySelector('.js-ive-popup-lightbox');
        if (lb && lb.parentNode) {
          closeLightbox();
        } else {
          closePopup();
        }
      }
    });
  }

  /* ---- Bootstrap ---- */

  function bootstrap() {
    initTrigger();
    initKeyboard();

    document.addEventListener('change', function(e) {
      var variantSelect = e.target.closest('.js-ive-popup-recommend-variant-select');
      if (!variantSelect) return;
      var productItem = variantSelect.closest('.js-product-item');
      var checkbox = productItem.querySelector('.js-ive-popup-rec-check');
      var selectedVariantId = variantSelect.value;
      checkbox.setAttribute('data-variant-id', selectedVariantId);

      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      var price = selectedOption.dataset.price;
      var compareAtPrice = selectedOption.dataset.compareAtPrice;
      var newImage = selectedOption.dataset.image;
      var newImageAlt = selectedOption.dataset.imageAlt;
      var priceEl = productItem.querySelector('.recommend-product-price');
      var ins = priceEl.querySelector('.js-price__current');
      var del = priceEl.querySelector('.js-price__compare');

      ins.textContent = price;

      if (newImage) {
        var img = productItem.querySelector('.js-recommend-checkbox label img');
        if (img) {
          img.src = newImage;
          if (newImageAlt) img.alt = newImageAlt;
        }
      }
      if (compareAtPrice) {
        if (del) {
          del.textContent = compareAtPrice;
        } else {
          var newDel = document.createElement('del');
          newDel.className = 'js-price__compare';
          newDel.style.fontSize = 'var(--12-14)';
          newDel.textContent = compareAtPrice;
          priceEl.appendChild(newDel);
        }
      } else {
        if (del) del.remove();
      }

      var config = getDiscountConfig();
      if (config) { applyDiscountToItem(productItem, config); }

      var popupProduct = productItem.closest('.ive-popup-product');
      if (popupProduct && popupProduct._updateTotalPrice) {
        popupProduct._updateTotalPrice();
      }
    });

    if (!I.isProductPage && SWIPER_URL && !document.querySelector('script[src*="swiper.min.js"]')) {
      var swiperScript = document.createElement('script');
      swiperScript.src = SWIPER_URL;
      document.head.appendChild(swiperScript);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

})();
